import { CommonModule } from '@angular/common';
import { Component, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { TablerIconsModule } from 'angular-tabler-icons';
import { MaterialModule } from 'src/app/material/material.module';

@Component({
  selector: 'app-confirm-delete-obs-dialog',
  standalone: true,
  templateUrl: './confirm-delete-obs-dialog.component.html',
  styleUrls: ['./confirm-delete-obs-dialog.component.css'],
  imports: [CommonModule, MaterialModule, TablerIconsModule]
})
export class ConfirmDeleteObsDialogComponent {
  constructor(
    public dialogRef: MatDialogRef<ConfirmDeleteObsDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {}

  onConfirm() {
    this.dialogRef.close(true);
  }

  onCancel() {
    this.dialogRef.close(false);
  }
}
